import { UI } from '@/Components/UI';
import { RecipeCollectionPreview } from '@/types';
import { HTMLProps } from 'react';
import { twMerge } from 'tailwind-merge';

type RecipeCollectionImageProps = {
    collection: RecipeCollectionPreview,
    itemClassName?: string
} & HTMLProps<HTMLDivElement>

export const RecipeCollectionImage = ({ collection, itemClassName, className, ...rest }: RecipeCollectionImageProps) => {
    return (
        <div
            {...rest}
            className={twMerge('grid grid-cols-2 grid-rows-2 gap-2 size-full', className)}>
            {[...Array(4).keys()].map((index) => (
                collection.recipes[index] ? (
                    <UI.Image
                        key={index}
                        image={collection.recipes[index].titleImage}
                        alt={collection.recipes[index].title}
                        className={twMerge('size-full rounded-xl', itemClassName)}
                    />
                ) : (
                    <div
                        key={index}
                        className={twMerge('size-full rounded-xl bg-primary-container/50', itemClassName)}
                    />
                )
            ))}
        </div>
    );
};
